import { GLEnvironment, GrowelabEnv } from 'src/app/common/types/env';

export const environment: GrowelabEnv = {
  apiUrl: 'https://api.estudio.local:8010', // URL of API backend
  environment: GLEnvironment.LOCAL, // one of enumerated environment values
  production: false, // whether this is a production build and deploy of the app
  sessionTimeoutMinutes: 30, // the number of minutes before the user session should expire

  // vendor-specific settings below
  cleverClientId: 'b7f08b4e62eb3a698369', // Clever (https://clever.com/) client ID
  cleverRedirectURI: 'http://localhost:4200/clever-auth',
  googleAnalyticsID: '', // Google Analytics datasource ID
  googleOAuthClientId:
    '605621249953-8uj4k1t6a7046de2mhqu8bqbnhhgvule.apps.googleusercontent.com', // Google Auth Client ID
  intercomId: 'zygq10l8', // Intercom chatbot ID
  pusher: {
    key: 'a4e041dfa30f25ef9d4e',
    cluster: 'us2',
  }, // Pusher (https://pusher.com/) configuration
  unleash: {
    url: 'https://us.app.unleash-hosted.com/usgg0020/api/frontend',
    clientKey:
      'default:development.e015f4519cbc879fa7f66e9385d6df6782d126dbbf6fbfd32a04e397',
  }, // configuration for Unleash (https://www.getunleash.io/) feature flag service
  getstream_appid: '1294595',
  getstream_key: '6nf5nva4bktq',
  ckEditor: {
    licenseKey:
      'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3OTQwOTU5OTksImp0aSI6ImI2OGUwMGM0LTQyYzUtNGM0ZC1hMDgyLTk2Y2ExZTgxNzE0ZSIsImxpY2Vuc2VkSG9zdHMiOlsiMTI3LjAuMC4xIiwibG9jYWxob3N0IiwiMTkyLjE2OC4qLioiLCIxMC4qLiouKiIsIjE3Mi4qLiouKiIsIioudGVzdCIsIioubG9jYWxob3N0IiwiKi5sb2NhbCJdLCJ1c2FnZUVuZHBvaW50IjoiaHR0cHM6Ly9wcm94eS1ldmVudC5ja2VkaXRvci5jb20iLCJkaXN0cmlidXRpb25DaGFubmVsIjpbImNsb3VkIiwiZHJ1cGFsIl0sIndoaXRlTGFiZWwiOnRydWUsImxpY2Vuc2VUeXBlIjoiZGV2ZWxvcG1lbnQiLCJmZWF0dXJlcyI6WyJEUlVQIiwiRE8iLCJGUCIsIlNDIiwiVE9DIiwiVFBMIiwiUE9FIiwiQ0MiLCJNRiIsIkUyUCIsIkUyVyIsIk1MTCIsIlNFRSIsIkVDSCIsIkVJUyIsIkxIIiwiRk9PIiwiQ01UIiwiVEMiLCJSSCIsIlJFIiwiUkNNVCIsIlJUQyIsIlJSSCIsIklXIl0sInZjIjoiODdjMzg0YTYifQ.eZC3jXq3ZrRQ6TWcWIImY-NVMmMva81KW-t-b5ubBWfxZ9ywXuuD4Lw9eXE8PwBbCQShperZkcca5AjN9iqG6Q',
    cloudServices: {
      websocketUrl: 'wss://jtoekhm1b7mm.cke-cs.com/ws',
      bundleVersion: 'growelab-editor-1.0.6',
    },
    environmentId: 'your-environment-id',
  },
};
